import moment from 'moment';
import { replaceSpecialChars } from 'utils/utils';
import { accentReplace } from 'utils/textFormatter';

export const updateLeadParams = ({
  cliFirstName,
  cliLastName,
  cliMotherName,
  identificationType,
  identificationId,
  duplicadoId,
  CC,
  expirationdate,
  dateOfBirth,
  cliTelephone,
  email,
  gender,
}) => {
  return {
    leadStep: '4',
    activateService: {
      comments: '',
      createCustomerMutation: {
        individualsCreateMutation: {
          included: {
            newInstance: {
              attributes: {
                employer: {
                  businessActivity: '',
                  name: '',
                  phone: '',
                  position: '',
                },
                typeOfclient: '',
                dateOfBirth: `${moment(dateOfBirth, 'DD/MM/YYYY' ).format('YYYY-MM-DD')}`,
                familyName: `${accentReplace(cliLastName)} ${accentReplace(cliMotherName)}`,
                gender: gender === 'Masculino' ? 'M' : 'F',
                givenName: accentReplace(cliFirstName),
                maritalStatus: 'Single',
                nationality: '8',
                profession: '3',
              },
              included: {
                contactMedia: [
                  {
                    attributes: {
                      medium: {
                        emailAddress: {
                          email: `${email}`,
                        },
                      },
                      mediumType: 'emailAddress',
                      role: 'primary',
                    },
                  },
                  {
                    attributes: {
                      medium: {
                        telephoneNumber: {
                          number: replaceSpecialChars(cliTelephone),
                          numberType: 'mobile',
                        },
                      },
                      mediumType: 'telephoneNumber',
                      role: 'primary',
                    },
                  },
                ],
                identifications: [
                  {
                    attributes: {
                      identificationId: `${identificationId}`,
                      identificationType: `CED`,
                      expirationdate: `${moment(expirationdate, 'DD/MM/YYYY').format('YYYY-MM-DD')}`,
                      issuingAuthority: {
                        city: '106',
                        country: '10',
                        stateOrProvince: '7',
                      },
                    },
                  },
                  {
                    attributes: {
                      identificationId: duplicadoId || '',
                      identificationType: 'ComplementoCI',
                      issuingAuthority: {
                        city: '',
                        country: '',
                        stateOrProvince: '',
                      },
                    },
                  },
                  {
                    attributes: {
                      identificationId: `${identificationId}`,
                      identificationType: 'NIT',
                      issuingAuthority: {
                        city: '',
                        country: '',
                        stateOrProvince: '',
                      },
                    },
                  },
                  {
                    attributes: {
                      identificationId: '1',
                      identificationType: 'RazonSocialTipo',
                      issuingAuthority: {
                        city: '',
                        country: '',
                        stateOrProvince: '',
                      },
                    },
                  },
                  {
                    attributes: {
                      identificationId: `${accentReplace(cliFirstName)} ${accentReplace(cliLastName)} ${accentReplace(
                        cliMotherName
                      )}`,
                      identificationType: 'RazonSocial',
                      issuingAuthority: {
                        city: '',
                        country: '',
                        stateOrProvince: '',
                      },
                    },
                  },
                ],
              },
            },
          },
        },
      },
      waitForDownPayment: '',
    },
  };
};
